export default {
  EVENTSTORE_BASE_URL: process.env.REACT_APP_EVENTSTORE_BASE_URL,
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
  SENTRY_ENV: process.env.REACT_APP_SENTRY_ENV,
  NODE_ENV: process.env.NODE_ENV
}
